












import { Vue, Component, Prop } from "vue-property-decorator";
import { EquatorialCoord } from "@hscmap/angle";
import { BookmarkEntry, IBookmark, IBookmarkFolder } from "../";
import { walkBookmarks } from "../walk";
import { store } from '@/store';
import * as easing from '@hscmap/easing'

@Component
export default class BookmarkEntryComponent extends Vue {
  @Prop()
  entry!: BookmarkEntry

  goto() {
    const globe = store.currentGlobe()
    const { view } = this.entry as IBookmark
    const { a, d, fovy, roll } = view
    const coord = EquatorialCoord.fromRad(a, d)
    globe.viewFactory.jumpTo({ fovy, roll }, { coord, duration: 4000, easingFunction: easing.slowStartStop4 })
  }

  get BookmarkEntry() {
    return BookmarkEntryComponent
  }

  walk(folder: IBookmarkFolder) {
    walkBookmarks(folder, store, this.module)
  }

  get module() {
    return this.Store.modules.bookmark
  }
}
